import { AlertTriangle, Shield, Skull } from 'lucide-react'

interface DangerIndicatorProps {
  level: number
}

export function DangerIndicator({ level }: DangerIndicatorProps) {
  const normalizedLevel = Math.max(1, Math.min(10, level))
  
  const getColor = () => {
    if (normalizedLevel <= 3) return 'text-green-500'
    if (normalizedLevel <= 5) return 'text-yellow-500'
    if (normalizedLevel <= 7) return 'text-orange-500'
    return 'text-red-500'
  }
  
  const getBgColor = () => {
    if (normalizedLevel <= 3) return 'bg-green-500'
    if (normalizedLevel <= 5) return 'bg-yellow-500'
    if (normalizedLevel <= 7) return 'bg-orange-500'
    return 'bg-red-500'
  }
  
  const getIcon = () => {
    if (normalizedLevel <= 3) return <Shield className="h-4 w-4" />
    if (normalizedLevel <= 7) return <AlertTriangle className="h-4 w-4" />
    return <Skull className="h-4 w-4" />
  }
  
  const getLabel = () => {
    if (normalizedLevel <= 2) return '安全'
    if (normalizedLevel <= 4) return '注意'
    if (normalizedLevel <= 6) return '警戒'
    if (normalizedLevel <= 8) return '危険'
    return '極度危険'
  }
  
  return (
    <div className="flex items-center gap-2">
      <div className={`flex items-center gap-1 ${getColor()}`}>
        {getIcon()}
        <span className="font-bold text-sm">
          危険度: {normalizedLevel}/10
        </span>
        <span className="text-xs">
          ({getLabel()})
        </span>
      </div>
      <div className="flex gap-0.5">
        {Array.from({ length: 10 }).map((_, i) => (
          <div
            key={i}
            className={`w-2 h-2 rounded-full transition-colors ${
              i < normalizedLevel ? getBgColor() : 'bg-gray-300'
            }`}
          />
        ))}
      </div>
    </div>
  )
}